import React from "react";
import backgroundImage from "../../assets/img/fondoSiete.png";
import HeaderAdmin from "../header/HeaderAdmin";
import { Link, useLocation } from "react-router-dom";
import useCrearPregunta from "../../hooks/useCrearPregunta";

const CrearPregunta = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Detectar si es desafío final (por path)
  const isFinal = location.pathname.includes("final");

  const nivelId = isFinal
    ? null // se resolverá en el hook con fallback
    : searchParams.get("nivel");

  const {
    niveles,
    pregunta,
    handleChange,
    handleRespuestaChange,
    enviarPregunta,
  } = useCrearPregunta({ nivelId });

  return (
    <div
      className="min-h-screen flex flex-col font-montserrat"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <HeaderAdmin />

      <div className="bg-white w-full py-2 text-center text-lg font-extrabold mt-2">
        Crear nueva pregunta
      </div>

      <div className="flex-grow flex justify-center mt-2 mb-10 px-4">
        <div className="w-full max-w-6xl bg-white m-2 p-4 rounded-lg overflow-y-auto relative">
          <Link to="/admin/niveles-preguntas" className="absolute top-4 left-4">
            <button
              type="button"
              className="bg-yellow-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-yellow-600 transition-colors text-sm"
            >
              Volver
            </button>
          </Link>

          <form onSubmit={enviarPregunta} className="space-y-4 mt-12">
            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mb-4">
              <div className="w-full md:w-1/3">
                <label
                  className="block text-sm font-bold mb-2"
                  htmlFor="tipo_pregunta"
                >
                  Tipo de pregunta
                </label>
                <select
                  id="tipo_pregunta"
                  name="tipo_pregunta"
                  value={pregunta.tipo_pregunta}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 bg-white shadow-sm"
                >
                  <option value="opcion_multiple">Opción múltiple</option>
                  <option value="verdadero_falso">Verdadero/Falso</option>
                </select>
              </div>

              <div className="w-full md:w-1/3">
                <label
                  className="block text-sm font-bold mb-2"
                  htmlFor="limite_tiempo"
                >
                  Límite de tiempo (segundos)
                </label>
                <input
                  type="number"
                  id="limite_tiempo"
                  name="limite_tiempo"
                  value={pregunta.limite_tiempo}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 bg-white shadow-sm"
                />
              </div>
            </div>

            <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mb-4">
              <div className="w-full md:w-1/2">
                <label
                  className="block text-sm font-bold mb-2"
                  htmlFor="texto_pregunta"
                >
                  Texto de la pregunta
                </label>
                <textarea
                  id="texto_pregunta"
                  name="texto_pregunta"
                  value={pregunta.texto_pregunta}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 h-32"
                />
              </div>

              <div className="w-full md:w-1/2">
                <label
                  className="block text-sm font-bold mb-2"
                  htmlFor="retroalimentacion"
                >
                  Retroalimentación
                </label>
                <textarea
                  id="retroalimentacion"
                  name="retroalimentacion"
                  value={pregunta.retroalimentacion}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 h-32"
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-bold mb-2">Respuestas</label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {pregunta.respuestas
                  .slice(
                    0,
                    pregunta.tipo_pregunta === "verdadero_falso" ? 2 : 4
                  )
                  .map((respuesta, index) => (
                    <div key={index} className="relative">
                      <input
                        type="text"
                        name="texto_respuesta"
                        value={respuesta.texto_respuesta}
                        onChange={(e) => handleRespuestaChange(index, e)}
                        placeholder={`Opción ${index + 1}`}
                        required={index < 2}
                        readOnly={pregunta.tipo_pregunta === "verdadero_falso"}
                        className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-600 ${
                          respuesta.es_correcta ? "bg-green-100" : ""
                        }`}
                      />
                      <input
                        type="radio"
                        name="es_correcta"
                        checked={respuesta.es_correcta}
                        onChange={(e) => handleRespuestaChange(index, e)}
                        className="absolute top-2 right-2 h-5 w-5 text-green-600 border-gray-300 focus:ring-green-500"
                      />
                    </div>
                  ))}
              </div>
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                className="w-full md:w-1/2 mt-6 bg-green-600 text-white font-bold py-3 px-6 rounded-lg hover:bg-green-700 transition-colors"
              >
                Crear pregunta
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CrearPregunta;
